import React from "react";
import { connect } from "react-redux";
import { addVisit, IVisit } from "../../../redux/modules/visits";
import history from "../../../history";
import { searchClients, clearSearch } from "../../../redux/modules/search";
import { RootState } from "../../../redux";
import VisitForm from "../../VisitForm";
import { withRouter } from "../../../hooks/withRouter";
import { ISearchClient } from "../../../redux/modules/search";
import "./create-visit.css";

interface CreateVisitPageProps {
  addVisit?: (visit: Partial<IVisit>, callBack: (newVisit: IVisit) => void) => void;
  searchClients?: (query: string) => Promise<void>;
  clearSearch?: () => void;
  router?: { location?: { search?: string } };
  clients?: ISearchClient[];
}

interface CreateVisitState {
  clientId: number;
  clientName: string;
  filter: string;
}

class CreateVisitPage extends React.Component<CreateVisitPageProps, CreateVisitState> {
  constructor(props: CreateVisitPageProps) {
    super(props);
    const searchParams = props?.router?.location?.search;
    if (searchParams && searchParams.includes("?clientId=")) {
      const [clientId, clientName] = searchParams.slice(1, searchParams.length).split("&");
      this.state = { clientId: +clientId.split("=")[1], clientName: decodeURIComponent(clientName.split("=")[1]), filter: "" };
    } else {
      this.state = { clientId: 0, clientName: "", filter: "" };
    }
  }

  handleClientSelect = (clientId: number, clientName: string) => {
    this.setState({ clientId, clientName, filter: "" });
    this.props.clearSearch && this.props.clearSearch();
  };

  applyFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
    const filter = e.target.value;
    if (filter && filter.length > 2) {
      this.props.searchClients && this.props.searchClients(filter);
    } else {
      this.props.clearSearch && this.props.clearSearch();
    }
    this.setState({ filter });
  };

  componentWillUnmount() {
    this.props.clearSearch && this.props.clearSearch();
  }

  renderClientList() {
    if (!this.props.clients || this.props.clients.length === 0) {
      return (
        <div className="create-visit__empty">
          <p className="create-visit__empty-text">Клієнтів не знайдено</p>
        </div>
      );
    }
    return this.props.clients.map((c) => {
      return (
        <div key={c.id} className="create-visit__client-item" onClick={() => this.handleClientSelect(c.id, c.name)}>
          <div className="create-visit__client-icon">👤</div>
          <div className="create-visit__client-name">{c.name}</div>
          <div className="create-visit__client-arrow">→</div>
        </div>
      );
    });
  }

  renderFirstStep() {
    if (this.state.clientId) {
      return (
        <div className="create-visit__selected-client">
          <div className="create-visit__selected-client-card">
            <div className="create-visit__selected-client-content">
              <div className="create-visit__selected-client-icon">👤</div>
              <div className="create-visit__selected-client-info">
                <h3 className="create-visit__selected-client-name">{this.state.clientName}</h3>
                <p className="create-visit__selected-client-label">Вибраний клієнт</p>
              </div>
            </div>
            <button
              type="button"
              className="create-visit__btn-change-client"
              onClick={() => {
                this.setState({ clientId: 0, clientName: "" });
                this.props.clearSearch && this.props.clearSearch();
              }}
            >
              <span className="create-visit__btn-change-icon">🔄</span>
              Вибрати іншого клієнта
            </button>
          </div>
        </div>
      );
    }
    return (
      <div className="create-visit__client-selection">
        <div className="create-visit__client-selection-card">
          <h2 className="create-visit__section-title">Оберіть клієнта</h2>
          <p className="create-visit__section-subtitle">Почніть вводити ім'я клієнта для пошуку</p>
          <div className="create-visit__search-group">
            <label className="create-visit__search-label">Пошук клієнта</label>
            <input
              className="create-visit__search-input"
              type="text"
              value={this.state.filter}
              onChange={this.applyFilter}
              placeholder="Введіть ім'я клієнта..."
            />
          </div>
          {this.state.filter.length > 2 && (
            <div className="create-visit__client-list">{this.renderClientList()}</div>
          )}
        </div>
      </div>
    );
  }

  saveHandler = (visit: Partial<IVisit>) => {
    this.props.addVisit && this.props.addVisit(visit, (savedVisit: IVisit) => history.push(`/visit/${savedVisit.id}`));
  };

  renderSecondStep() {
    if (!this.state.clientId || !this.state.clientName) {
      return null;
    }
    return (
      <div className="create-visit__form-section">
        <div className="create-visit__form-container">
          <VisitForm clientId={this.state.clientId} clientName={this.state.clientName} saveHandler={this.saveHandler} />
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="create-visit">
        <div className="create-visit__header">
          <h1 className="create-visit__title">Створити Візит</h1>
          <p className="create-visit__subtitle">Додайте новий візит для клієнта</p>
        </div>
        {this.renderFirstStep()}
        {this.renderSecondStep()}
      </div>
    );
  }
}

const mapStateToProps = (state: RootState) => {
  return { clients: state.searchState.clients };
};

export default withRouter(connect(mapStateToProps, { addVisit, clearSearch, searchClients })(CreateVisitPage));